export const IMAGES_TYPES = {
    PNG: 'image/png',
    JPEG: 'image/jpeg',
    JPG: 'image/jpg'
}